import { render, staticRenderFns } from "./NodeView.vue?vue&type=template&id=4c1a33a8&scoped=true&lang=pug"
import script from "./NodeView.vue?vue&type=script&lang=js"
export * from "./NodeView.vue?vue&type=script&lang=js"
import style0 from "./NodeView.vue?vue&type=style&index=0&id=4c1a33a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a33a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Editor: require('/home/docker/code/frontend/components/Editor.vue').default})
